module.exports = __webpack_public_path__ + "static/media/about.3df86555.md";